




















import Vue from 'vue'
import { some, find } from 'lodash'
import { Widget } from '@/types/widgets'
import { KeyDict } from '@/types'
import { AssetType } from '@/types/assets'
import './ManageWidgets.scss'

export default Vue.extend({
  name: 'ManageWidgets',
  props: {
    widgets: {
      type: Object as () => KeyDict<Widget>,
      required: true
    }
  },
  data: () => ({
    chat: false,
    editWidgets: {} as KeyDict<Widget>
  }),
  created (): void {
    this.editWidgets = JSON.parse(JSON.stringify(this.widgets))
    this.chat = this.hadWidget(AssetType.Chat)
  },
  watch: {
    chat (newValue: boolean): void {
      this.handleChange(AssetType.Chat, newValue)
    }
  },
  methods: {
    handleChange (widgetType: AssetType, newValue: boolean): void {
      const noChanges = newValue === this.hadWidget(widgetType)
      if (noChanges) {
        /* istanbul ignore next */
        return
      }
      if (newValue) {
        this.addWidget(widgetType)
      } else {
        this.removeWidget(widgetType)
      }
      this.$emit('changed', this.editWidgets)
    },
    hadWidget (widgetType: AssetType): boolean {
      return some(this.editWidgets, (widget: Widget) => widget.type === widgetType)
    },
    findWidget (widgetType: AssetType): Widget | undefined {
      return find(this.editWidgets, (widget: Widget) => widget.type === widgetType)
    },
    addWidget (widgetType: AssetType): void {
      const newWidget = new Widget(widgetType)
      this.editWidgets[newWidget.id] = newWidget
    },
    removeWidget (widgetType: AssetType): void {
      const deleteWidget = this.findWidget(widgetType)
      if (deleteWidget) delete this.editWidgets[deleteWidget.id]
    }
  }
})
